<script setup lang="ts">
import merge from 'lodash-es/merge';
import { useWebsitesStore } from '#layers/cms/app/pages/cms/management/websites/_runtime/stores/websites';
import type { PageListItemModel } from '#layers/cms/app/pages/cms/management/pages/_runtime/services/PagesService';
import PagesService from '#layers/cms/app/pages/cms/management/pages/_runtime/services/PagesService';
import Multiselect from 'vue-multiselect/src/Multiselect.vue';
import * as yup from 'yup';

interface FormSettings
{
    settings: any;
}

defineOptions({
    name: 'WidgetIntLinkSettings'
});

const emit = defineEmits<{
    (e: 'update:modelValue', payload: any): void;
}>();

const props = defineProps<{
    modelValue: any;
}>();

const module = ref<string>('link');
const defaults = ref<any>({
    pages: []
});

const pageOptions = ref<PageListItemModel[]>([]);

const form = computed<FormType<FormSettings>>(() =>
{
    return props.modelValue;
});

const current = computed((): CurrentWebsite =>
{
    return useWebsitesStore().current;
});

const selectedPageOptions = computed<Option[]>(() =>
{
    return pageOptions.value.map((p) =>
    {
        return { value: p.id.toString(), text: p.option };
    });
});

async function loadPages(): Promise<void>
{
    try
    {
        pageOptions.value = await PagesService.getPagesByModule(current.value.website, current.value.locale, module.value);
        pageOptions.value = pageOptions.value.filter(x => x.id != 0);
    }
    catch (ex)
    {
        pageOptions.value = [];
        $log.debug(ex);
    }
}

async function validate(): Promise<void>
{
    form.value.validate(schema => ({
        settings: schema.object({
            pages: yup.array().min(1, $t('[[[Wybranie strony jest wymagane]]]'))
        })
    }));
}

const triggetModel = (): void =>
{
    emit('update:modelValue', form.value);
};

watch(() => form.value.settings, (value: any) =>
{
    triggetModel();
}, { deep: true });

onBeforeMount(async (): Promise<void> =>
{
    await wait(() => current.value.website);
    await loadPages();
    form.value.settings = merge(defaults.value, form.value.settings);
});

defineExpose({
    validate
});
</script>

<template>
    <IdeoFormGroup :label="$t('[[[Wybór listy stron]]]')" :invalid-feedback="form.$errors.first('settings.pages')" :state="form.$errors.state('settings.pages')" required>
        <Multiselect
            v-model="form.settings.pages"
            label="text"
            track-by="value"
            :options="selectedPageOptions"
            :multiple="true"
            :placeholder="$t('[[[Wybierz strony]]]')"
        >
            <template #noOptions>
                {{ $t('[[[Lista jest pusta]]]') }}
            </template>
            <template #noResult>
                {{ $t('[[[Nie znaleziono żadnych wyników.]]]') }}
            </template>
        </Multiselect>
    </IdeoFormGroup>
</template>
